angular.module('env.data.services.geocoding', [])

    .run(function (geocodingService) {

    })

    .provider('geocodingService', function (EventingMixin) {
        var _this = this;

        this.$get = function ($log, $q, $timeout, $localStorage, $http, authService) {

            /**
             * Performs forward geocoding request using OM Web API Geocoding module
             * @param address - Address to perform geocoding request for and get Longitude and Latitude values
             * @returns {HttpPromise} Future object
             */
            _this.getGeocodingForAddress = function (address) {
                var token = authService.getToken();
                if (!token) {
                    $log.error('Can not perform geocoding api request. Error: Not authorized.');
                    return [];
                }
                var config = { headers: { Authorization: token } };

                var data = { address: address };

                return $http
                    .post(om.config.build.baseUrl + "/geocoding/forward-geocode/", data, config)
                    .then(
                        function (resp) {
                            if (resp.data && resp.data.length > 0) {
                                var place = null;

                                //get the last one as the most general specified place (house, building)
                                var lastIndexOfBld = _.findLastIndex(resp.data, function (place) { return place.class === 'building' || place.type === 'house'; });
                                if (lastIndexOfBld !== -1) {
                                    place = resp.data[lastIndexOfBld];
                                } else {
                                    place = _.last(resp.data);
                                }

                                return place;
                            }

                            return null;
                        },
                        function (error) {
                            $log.error('Error during forward geocode request to geocoding api. Error: ' + error);
                            return $q.reject(error);
                        });
            };

            return _this;
        };


    })

    ;
